import React, { Component, useEffect, useState, useRef } from 'react';
import { Link, useParams, Router,useNavigate } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, Row } from 'reactstrap';
import { Alert } from "reactstrap"
import $ from "jquery";
import Header from '../header.js';
import Tremester from '../Model/Tremester';
import Faculty from '../Faculty/Faculty.js';
import { ToastContainer } from 'react-toastify';
import Professionaldiplomas from '../Professionaldiplomas/Professionaldiplomas.js';
import Proseminars from '../Proseminars/Proseminars.js';
import Lecturespresentations from '../Lecturespresentations/Lecturespresentations.js';
import Courses from '../courses/courses.js';
import DegreePrograms from '../degreePrograms/DegreePrograms';
import Program from '../program/Program.js';
import Professionalcertificates from '../Professionalcertificates/Professionalcertificates.js';
import { API_URL } from '../../../Config/index.js';
import CapnoLearningCard from './BrochureCard.js';
import CapnoLearningNewCourseCard from './CapnoLearningNewCourseCard.js';




const Dashboard = (props) => {

    // const trimester 
    const [orderedItems, setOrderedItems] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const referer = localStorage.getItem('referer');
    
    const [course, setCourse] = useState({});
    const { type } = useParams();
    const { trimester } = useParams();
    // alert(trimester);
    const [diplomacourse, setDiplomacourse] = useState([]);
    const [ProseminarsCourse, setProseminarsCourse] = useState([]);
    const [courses, setCourses] = useState([]);
    const [ProfessionalCertificates, setProfessionalCertificates] = useState([]);
    const [SpecialEvents, setSpecialEvents] = useState([]);

    const [checkoutsuccessModel, setCheckoutsuccess] = useState(false);
    const checkoutsuccessToggleModal = () => setCheckoutsuccess(!checkoutsuccessModel);

    
    const [registering, setRegistering] = useState(false);
    const [logging, setLogging] = useState(false);

    const [selectcourseModel, setSelectcourse] = useState(false);
    const selectcourseToggleModal = () => setSelectcourse(!selectcourseModel);

    const [loginModel, setLoginModel] = useState(false);
    const LoginToggleModal = () => setLoginModel(!loginModel);
    const [mail, setMail] = useState("");
    const [pass, setPass] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [alert, setAlert] = useState(false);
    const [existingUserId, setExistingUserId] = useState(null);
    const [balanceAmount, setBalanceAmount] = useState(0);
    const [balanceAmountDiscount, setBalanceAmountDiscount] = useState(0);
    const [totalCostDiscount, setTotalCostDiscount] = useState(0);
    const [totalActualCost, setTotalActualCost] = useState(0);
    
    const [scholarshipCode, setScholarshipCode] = useState(null);
    const [poNumber, setPoNumber] = useState(null);
    const [scapplied, setScapplied] = useState(null);
    const [poapplied, setPoapplied] = useState(null);
    const [codeError, setCodeError] = useState(null);

    const [paymentOption, setPaymentOption] = useState("deposit");
    const [installmentDates, setInstallmentDates] = useState([]);
    const installmentFee = 50;
    

    
    const Navigate = useNavigate();


    const [messageModal, setmessageModal] = useState(false);
    const messageToggle = () => setmessageModal(!messageModal);

    const [message, setmessage] = useState(false);
    const [messageHead, setmessageHead] = useState(false);

 
    const [payPalModal, setPayPalModal] = useState(false);
    const payPalToggle = () => setPayPalModal(!payPalModal);

    const [discoutModal, setDiscoutModal] = useState(false);
    const discoutToggle = () => setDiscoutModal(!discoutModal);

    const tabArray = [
        {
            types: "diploma", tabDisplay: "Professional Diplomas"
        },
        {
            types: "Program", tabDisplay: "Certification Programs"
        },
        {
            types: "course", tabDisplay: "Professional Certificates"
        },
        {
            types: "Proseminar", tabDisplay: "Proseminars"
        },
        {
            types: "SE", tabDisplay: "Special Events"
        },



    ];


    useEffect(() => {
        
        setExistingUserId(localStorage.getItem('existingUserId'));
        getprofesnaldiploma();
        getCourseProseminars();
        getCourses();
        Professional_Certificates();
        Special_Events();

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 300) {
                $('.checkout-box').addClass('fixed-box');

            }
            else {
                $('.checkout-box').removeClass('fixed-box');

            }
        });

        changePickupStoreMenu();

        function changePickupStoreMenu() {



        }


    }, [])

    const LoginUser = async () => {
        setLogging(true);

        let result = await fetch(API_URL+'/login', {
            method: 'POST',
            
            body: JSON.stringify({
                mail,
                pass
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        result = await result.json();
        console.warn(result);
        setAlert(false);
        if (result.success) {
            payPalToggle();

            localStorage.setItem('existingUserId' , result.user)
            setExistingUserId(result.user);
            LoginToggleModal();
            setLogging(false);

        //     setTimeout(() => {
        //         payNow(result.user) ;
        //    },2000)
            // Navigate('/');
        }
        else {
            setAlert(true);
            setLogging(false);

        }
    }
    
    const applyponumber = async () => {
     

        let result = await fetch(API_URL+'/apply/ponumber', {
            method: 'POST',
            
            body: JSON.stringify({
                code : poNumber,
                payable: totalCost,
                balance : balanceAmount
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        result = await result.json();
        console.warn(result);
        setCodeError(false);
        setScapplied(false);
        setPoapplied(false);
        setTotalCostDiscount(0);
        setBalanceAmountDiscount(0);
        if (result.success) {
            if(result.exist){
                setTotalCostDiscount(result.discount_amount);
                setBalanceAmountDiscount(result.balance)
                setPoapplied(true);
            //     setTimeout(() => {
            //         payNow(existingUserId) ;
            //    },2000)

            }
            else{
                setCodeError("Invalid PO Number")
            //     setTimeout(() => {
            //         payNow(existingUserId) ;

            //    },2000)

            }

            // Navigate('/');
        }
        else {
            setCodeError("Some Error Occured!!!")
        //     setTimeout(() => {
        //                             payNow(existingUserId) ;

        //    },2000)

        }
    }


    const applyscholarshipcode = async () => {
     
        // $("#paypal-button-container").html('')
        let result = await fetch(API_URL+'/apply/scholarship', {
            method: 'POST',
            
            body: JSON.stringify({
                couponcode : scholarshipCode,
                semsid :  trimester,
                payable: totalCost,
                balance : balanceAmount
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        result = await result.json();
        console.warn(result);
        setCodeError(false);
        setScapplied(false);
        setPoapplied(false);
        setTotalCostDiscount(0);
        setBalanceAmountDiscount(0);
        if (result.success) {
            if(result.exist){
                setTotalCostDiscount(result.discount_amount);
                setBalanceAmountDiscount(result.balance)
                setScapplied(true);
//                 setTimeout(() => {
//                     payNow(existingUserId) ;

// },2000)
            }
            else{
                setCodeError("Invalid Code")
//                 setTimeout(() => {
//                     payNow(existingUserId) ;

// },2000)
            }

            // Navigate('/');
        }
        else {
            setCodeError("Some Error Occured!!!")
//             setTimeout(() => {
//                 payNow(existingUserId) ;

// },2000)
        }
    }

    useEffect(() => {
        if(existingUserId){
            // alert(existingUserId)
            payNow(existingUserId)
        }
       
    },[existingUserId,totalCostDiscount,totalCost,balanceAmount,balanceAmountDiscount,paymentOption]);

    const balanceDue = parseFloat(parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2));

    const formatDate = (ts) => {
        const date = new Date(ts * 1000); // Convert seconds to milliseconds
        return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    }

    // installment due dates of the selected course (from its start date)
    useEffect(() => {
        setInstallmentDates([]);
        const classes = orderedItems.map((v) => v.id).join(',');
        if(!classes){
            return;
        }
        let cancelled = false;
        fetch(API_URL+'/get/installment/dates/'+classes)
            .then((res) => res.json())
            .then((data) => {
                if(!cancelled && data.success){
                    setInstallmentDates(data.dates);
                }
            })
            .catch((err) => console.error("Error fetching installment dates:", err));
        return () => { cancelled = true; };
    },[orderedItems]);

    // balance split in 3 equal monthly installments from the course start date, fee added to the last one
    // (same calculation as getInstallmentSchedule in the api, the actual dates come from the api and are shown 2 days earlier here)
    const installmentCount = 3;
    const installmentDaysBefore = 2;
    // installments are only offered when a selected course has them enabled (course.pay_deposit_installment)
    const instalmentEnabled = orderedItems.some((v) => parseInt(v.pay_deposit_installment) == 1);
    const installments = instalmentEnabled && balanceDue > 0 && installmentDates.length == installmentCount ?
        Array.from({ length: installmentCount }, (_, i) => {
            const perInstallment = Math.floor((balanceDue / installmentCount) * 100) / 100;
            const isLast = i == installmentCount - 1;
            const amount = isLast ? balanceDue - perInstallment * (installmentCount - 1) + installmentFee : perInstallment;
            const date = formatDate(installmentDates[i] - installmentDaysBefore * 86400);
            return { date, amount: amount.toFixed(2), isLast };
        })
        : [];
    const payByInstallment = paymentOption == "installment" && installments.length > 0;

    const paymentOptionStyle = (option) => ({
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        padding: "10px 12px",
        marginBottom: "10px",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        border: paymentOption == option ? "2px solid #000" : "1px solid #00000052",
    });


    const payNow = (id) => {
        $("#paypal-button-container").html('')

       let _cost = parseFloat(totalCost - totalCostDiscount).toFixed(2);
       let _balanceAmount = parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2);
    //    let _cost = 0.01;
        paypal.Buttons({
          createOrder: function(data, actions) {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: parseFloat(_cost)
                }
              }]
            });
          },
          onApprove: function (data, actions) {
              return actions.order.capture().then(function (details) {
               //   console.log(details)
                
               completeRegisteration(id,details,_cost,_balanceAmount) ; 
                 
                })
              },
              onCancel: function (data) {
                 // window.location.replace("<?php echo $site_url;?>sales/CeRegister_new_back.php")
              }
        }).render('#paypal-button-container');
        
   }

   const completeRegisteration = async (id,details,_cost,_balanceAmount) => {
    setRegistering(true)
    let _temp = [] ; 
    orderedItems.map((v,i) => {
        _temp.push(v.id);
    })
    console.log(_temp);
    let classes = _temp.join(',');
    //    let classes = orderedItems.join(',')
       let semsids = trimester
       const response = await fetch(API_URL+'/complete/registration/existing/installment/'+id, {
           method: 'POST',
           headers: {
               'Content-Type': 'application/json',
           },
           body: JSON.stringify({
            classes : classes,
            semsids : semsids,
            details,
            paidAmount : _cost,
            discountcoupon : scholarshipCode,
            pocode : poNumber,
            balance : _balanceAmount,
            referer: referer,
            // saved as users_billing.paymentoption, the api creates the installment / deposit rows from it
            paymentMethod: payByInstallment ? "installment" : balanceDue > 0 ? "deposit" : "full",
            ...(payByInstallment ? { customerId: 0, paymentMethodToken: 0 } : {})
           }),
       })



       const data = await response.json()

       if(data.status){
           setmessageHead("Success!!")
           setmessage("Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time by clicking on <strong>`Student & Faculty Login`</strong> button to access course materials and listen to recordings of previous sessions. You will be provided with details during the first course session. <br /> <br /> Thank you!  We look forward to seeing you.") ;
           messageToggle();
            payPalToggle() ; 
            // setTotalCost(0) ;
            // setOrderedItems([])
           // setTimeout(() => {
           //     window.location.replace('https://e-campus.bp.edu/autologin.php?uid='+data.id)
           // },10000)

       }
       else{
           setmessageHead("Error!!")
           setmessage("Some Error Occured")
           messageToggle();


       }
   }

    const getprofesnaldiploma = () => {
        let semesters = trimester;
        let degreepro = "0";
        let category = type;


        fetch(API_URL+"/get/course/" + semesters + "/" + degreepro + "/" + category,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {

                    // console.log("result", resp);
                    setDiplomacourse(resp.data);

                });
            }



        })
    }

    


    const Special_Events = () => {
        let semesters = trimester;
        let degreepro = "0";
        let category = type;


        fetch(API_URL+"/get/course/" + semesters + "/" + degreepro + "/" + category,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.log("result", resp);
                    setSpecialEvents(resp.data);
                });
            }


        })
    }    
    const Professional_Certificates = () => {
        let semesters = trimester;
        let degreepro = "0";
        let category = type;


        fetch(API_URL+"/get/course/" + semesters + "/" + degreepro + "/" + category,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.log("result", resp);
                    setProfessionalCertificates(resp.data);
                });
            }


        })
    }


    const getCourses = () => {
        let semesters = trimester;
        let individual = "1";
        let category = type;

        fetch(API_URL+"/get/courses/" + semesters + "/" + individual + "/" + category,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    console.log("result", resp);
                    setCourses(resp.data);
                });
            }


        })
    }
    const getCourseProseminars = () => {
        let semesters = trimester;
        let degreepro = "0";
        let category = "Proseminar";

        fetch(API_URL+"/get/course/" + semesters + "/" + degreepro + "/" + category,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.log("result", resp);
                    setProseminarsCourse(resp.data);
                });
            }


        })
    }

    useEffect(() => {
        let _temp = [] ; 
        orderedItems.map((v,i) => {
            _temp.push(v.id);
        })
        // console.log(_temp);
        let classes = _temp.join(',');
        localStorage.setItem('trimester' , trimester);
        localStorage.setItem('classes' , classes);
        localStorage.setItem('totalCost' , totalCost);
        localStorage.setItem('balanceAmount' , balanceAmount);
    },[orderedItems,totalCost,balanceAmount,trimester]);




    const handleChange = (item, event) => {
        if (event.target.checked) {
            setOrderedItems((cartItem) => [...cartItem, item]);
            console.log(item.bamount_new);
            item.damount_new ? setTotalCost((total) => total + parseInt(item.damount_new)) : setTotalCost((total) => total + parseInt(item.price));
            item.bamount_new ? setBalanceAmount(item.bamount_new) : setBalanceAmount(0) ;

             setTotalActualCost((total) => total + parseInt(item.price)) ;

            
            // item.bamount_new ? setBalanceDate(item.)
            // add item to orderedItems array
        } else {
            // remove item from orderedItems array
            setOrderedItems((cartItem) =>
                cartItem.filter((v) => v.name !== item.name)
            );



            item.bamount_new ? setTotalCost((total) => total - parseInt(item.damount_new)) : setTotalCost((total) => total - parseInt(item.price));
            setBalanceAmount(0) ;
            setTotalActualCost((total) => total - parseInt(item.price)) ;

            // setTotalCost((total) => total - parseInt(item.price));
        }
    };

    const handlechaeckOut = () => {
        if (orderedItems.length > 0) {
            
            // console.log(classes)
            checkoutsuccessToggleModal()
        }
        else {
            selectcourseToggleModal()
        }

    }


    // const handlelogin = ()=>{
    //     // if(){

    //     // }
    // }


    return (
        <div>


            <div className='main-bg'>
                <Header />

                <Faculty message={"Please register here."} />
                <div className='container'>
                    {/* <div className='winter-heading'>
                        <h3>Registration</h3>
                    </div>
                     */}
                </div>
                <div className='container-fluid'>
                    <div className='register-wrap'>
                        <div className='tab-list'>
                            <ul className='tab'>

                                {
                                    tabArray.map(function (v, i) {
                                        return (
                                            <li> <a href={"/registration/" + trimester + "/" + v.types} className={type == v.types ? "tabs active" : "tabs"}>{v.tabDisplay}</a></li>
                                        )
                                    }

                                    )
                                }

                                <div className="wrp-checkout-box">
                                    <div className="checkout-box">
                                        <p>Total Amount: ${totalActualCost}</p>
                                        {/* <p>Deposit Amount: ${totalCost}</p> */}
                                        <a onClick={handlechaeckOut}>CheckOut</a>
                                    </div>
                                </div>
                                {/* <div><a href='#' onClick={discoutToggle}>click here</a></div> */}

                            </ul>
                        </div>
                        <div className='tab-line'></div>

                        <div className="right-section" style={{"display": "flex" , "flexDirection": "column"}}>
                            <Tremester />
                            <div className="right-d-box">
                                <div className='tab-c-h'>
                                    {/* <h6>Professional Diplomas</h6>
                                    <div className='tab-c-h-line'></div> */}
                                </div>


                                {
                                    type == "diploma" &&
                                    diplomacourse.length > 0 && diplomacourse.map((v, i) => {
                                        return (
                                            <Professionaldiplomas data={handleChange} {...v} />
                                        )

                                    })

                                }
                                {
                                    type == "diploma" &&
                                    diplomacourse.length == 0 &&
                                    <p className="not-faund">No Professional Diplomas found</p>

                                }
                                {
                                    type == "Program" &&
                                    ProfessionalCertificates.length > 0 && ProfessionalCertificates.map((pvalue, i) => {
                                        return (
                                            <Professionalcertificates data={handleChange} {...pvalue} />
                                        )
                                    })

                                }


                                  {
                                    type == "Program" &&
                                    ProfessionalCertificates.length  == 0 &&
                                    <p className="not-faund">No Programs found</p>


                                }

                                {
                                    type == "course" &&
                                    courses.length > 0 && courses.map((Cvalue, i) => {
                                        return (
                                            Cvalue.category == "course" ? <Courses data={handleChange} {...Cvalue} /> : <Professionalcertificates data={handleChange} {...Cvalue} />
                                        )
                                    })

                                }

                            
                                {
                                    type == "course" &&
                                    courses.length == 0 &&
                                    <p className="not-faund">No Professional Certificates found</p>

                                }


                                {
                                    type == "Proseminar" &&
                                    ProseminarsCourse.length > 0 && ProseminarsCourse.map((Pvalue, i) => {
                                        return (
                                            <Proseminars data={handleChange} {...Pvalue} />
                                        )
                                    })

                                }
                                {
                                    type == "Proseminar" &&
                                    ProseminarsCourse.length == 0 &&
                                    <p className="not-faund">No Proseminars found</p>

                                }
                                 {
                                    type == "SE" &&
                                    SpecialEvents.length > 0 && SpecialEvents.map((pvalue, i) => {
                                        return (
                                            <Professionalcertificates data={handleChange} {...pvalue} />
                                        )
                                    })

                                }
                                  {
                                    type == "SE" &&
                                    SpecialEvents.length  == 0 &&
                                    <p className="not-faund">No Special Events found</p>


                                }

                                {
                                    !type &&
                                    <p className="not-faund text-left pl-2" ><i className='fa fa-arrow-left'></i> Please make a selection</p>
                                }


                            </div>


                                {/* <CapnoLearningCard /> */}
                                   {
                                    type == "Program" &&
                                <CapnoLearningNewCourseCard />
                                 }
                        </div>
                        
                        <div className='tab-line' style={{marginRight: "2px"}}></div>
 
                    </div>
                 
                </div>
            </div>

            <Modal isOpen={checkoutsuccessModel} toggle={checkoutsuccessToggleModal} className="connect-box" centered={true}>
                <ModalHeader toggle={checkoutsuccessToggleModal}><span className="ml-1 roititle">Please register</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p">
                        <div>
                            <p> Click: <a href="/create"><u>New Student</u></a> <br /><br />  Click: <a href="#" onClick={() => { LoginToggleModal(); checkoutsuccessToggleModal(); }}><u>Existing Student</u></a></p>
                        </div>
                    </div>
                </ModalBody>

            </Modal>


            <Modal isOpen={selectcourseModel} toggle={selectcourseToggleModal} className="connect-box" centered={true}>
                <ModalHeader toggle={selectcourseToggleModal}><span className="ml-1 roititle">Please make a selection</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p">
                        <div>
                            <p>Please select at least one item in the list.</p>
                        </div>
                    </div>
                </ModalBody>

            </Modal>

            <Modal isOpen={loginModel} toggle={LoginToggleModal} className="connect-box" centered={true}>
                <ModalHeader toggle={LoginToggleModal}><span className="ml-1 credentials-title">Please enter your e-campus credentials to checkout</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p">
                            <div className='login-bg'>
                                <div className="wrp-login">

                                    <div className="login-content">
                                       
                                        <div className="wrp-label">
                                            <label>Email Address</label>
                                            <input
                                                value={mail} onChange={(e) => setMail(e.target.value)}
                                                type="email"
                                                placeholder="Email"
                                            />
                                        </div>
                                        <div className="wrp-label mrt-input">
                                            <label>Password</label>
                                            <div className="wrp-label" style={{ position: "relative" }}>
                                                <input
                                                    value={pass} onChange={(e) => setPass(e.target.value)}
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    style={{ paddingRight: "40px" }}
                                                />
                                                <i
                                                    className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#000" }}
                                                ></i>
                                            </div>
                                        </div>

                                        {
                                            alert &&
                                            <Alert color="danger">
                                                Invalid Login
                                            </Alert>
                                        }
                                        {
                                            logging ?
                                        <button className="login-btn" disabled>Logging in...</button>
                                            :
                                            <button className="login-btn" type="submit" onClick={LoginUser}  >CheckOut</button>
                                        }

                                    </div>

                                </div>
                            </div>
                    </div>
                </ModalBody>

            </Modal>

            <Modal isOpen={payPalModal} toggle={payPalToggle} className="connect-box" centered={true}>
                <ModalHeader toggle={payPalToggle}><span className="ml-1 roititle font-weight-bold">
                    {
                            parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) == 0 ?
                            <>
                            Amount Payable : ${parseFloat(totalCost -  totalCostDiscount).toFixed(2)}
                            </>
                            :
                            <>
                            Program Deposit : ${parseFloat(totalCost -  totalCostDiscount).toFixed(2)}
                             
                            </>
                    }
                    </span>
                </ModalHeader>
                <ModalBody>
                <div className="discount-btn">
                    {
                        balanceDue > 0 &&
                        <div>
                            {/* <p className='mb-2'><b>Please choose how you would like to pay the remaining balance:</b></p> */}
                            <label style={paymentOptionStyle("deposit")}>
                                <input
                                    type="radio"
                                    name="paymentOption"
                                    value="deposit"
                                    checked={paymentOption == "deposit"}
                                    onChange={() => setPaymentOption("deposit")}
                                    style={{ width: 14, height: 14, marginTop: 3, flexShrink: 0 }}
                                />
                                <span>
                                    <b>Balance due 2 days before program starts:</b> ${balanceDue.toFixed(2)}
                                </span>
                            </label>
                            {
                                installments.length > 0 &&
                                <label style={paymentOptionStyle("installment")}>
                                    <input
                                        type="radio"
                                        name="paymentOption"
                                        value="installment"
                                        checked={paymentOption == "installment"}
                                        onChange={() => setPaymentOption("installment")}
                                        style={{ width: 14, height: 14, marginTop: 3, flexShrink: 0 }}
                                    />
                                    <span>
                                        <b>Pay the balance in {installments.length} installments</b><br />
                                        {
                                            installments.map((v, i) => {
                                                return (
                                                    <span key={i} style={{ display: "block" }}>
                                                        Installment {i + 1}: ${v.amount} due on {v.date}
                                                    </span>
                                                )
                                            })
                                        }
                                    </span>
                                </label>
                            }
                        </div>
                    }
                       {
                           scapplied ? 
                           <p className='text-success'><i className='fa fa-check-circle'></i> Scholarship Code Applied</p>:
                           poapplied ? 
                           <p className='text-success'><i className='fa fa-check-circle'></i> PO Number Applied</p>
                           :
                           null
                       }
                        {
                        parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) > 0 &&
                       <hr />
                    }

                       {
                           codeError ?
                           <small className='text-danger'><i className='fa fa-times'></i> {codeError}</small>
                           :
                           null

                       }

                       <div className="coupon-wrp mb-4 mt-2">
                           <div className="coupon-child1">
                               <label><b>Scholarship Code</b></label>
                               <input onChange={(e) => setScholarshipCode(e.target.value)} placeholder='Enter Scholarship Code' />
                               <button onClick={applyscholarshipcode}>Apply</button>
                           </div>
                           <div className="coupon-child1 coupon-right">
                                <label><b>PO Number</b></label>
                                <input onChange={(e) => setPoNumber(e.target.value)} placeholder='Enter PO Number' />
                               <button onClick={applyponumber}>Apply</button>
                           </div>
                       </div>
                       {
                           registering &&
                           <button disabled={true}>Completing Registration...</button>

                       }
                       {
                           totalCost == totalCostDiscount && !registering &&
                           <button onClick={() =>  completeRegisteration(existingUserId,'',0,0)}>CheckOut</button>
                       }
                    </div>
                    {
                           totalCost != totalCostDiscount &&
                           <>
                         
                           <div
    data-pp-message
    data-pp-style-layout="text"
    data-pp-style-logo-type="inline"
    data-pp-style-text-color="black"
    data-pp-amount={totalCost}
    data-pp-placement="payment"
    data-pp-style-text-size="16" >
</div>
<div id="paypal-button-container">
                       
                       </div>
                           </>
                           
                    }
                
                </ModalBody>

            </Modal>

            <Modal isOpen={messageModal} toggle={messageToggle} className="connect-box" centered={true}>
                <ModalHeader toggle={messageToggle}><span className="ml-1 roititle font-weight-bold">{messageHead}</span></ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{__html : message}}>
                       
                    </div>
                </ModalBody>

            </Modal>

            {/* dicount modal open */}
            
            <Modal isOpen={discoutModal} toggle={discoutToggle} className="connect-box" centered={true}>
                <ModalHeader toggle={discoutToggle}><span className="ml-1 roititle font-weight-bold">Discount Coupon</span></ModalHeader>
                <ModalBody>
                    <div className="discount-btn">
                       <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate</p>
                       <div className="coupon-wrp">
                           <div className="coupon-child1">
                               <label>Course Coupon</label>
                               <input placeholder='Enter Coupon' />
                               <button>Apply</button>
                           </div>
                           <div className="coupon-child1 coupon-right">
                                <label>Course Coupon</label>
                                <input placeholder='Enter Coupon' />
                               <button>Apply</button>
                           </div>
                       </div>
                       <button>CheckOut</button>
                    </div>
                </ModalBody>

            </Modal>

            {/* dicount modal closed */}
        </div>
    );

}


export default Dashboard;